import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export function PageMeta(): JSX.Element {
	const {
		data: { title },
	} = usePageMeta();

	return (
		<Helmet>
			<title>{title}</title>
		</Helmet>
	);
}
